<template>
  <div class="wd-px-5">
    <v-skeleton-loader class="album-swiper-skeleton" type="ossein" />
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.album-swiper-skeleton {
  height: var(--album-swiper-height-desktop);

  @include xxs {
    height: var(--album-swiper-height-mobile);
  }
}
</style>
